import { render, staticRenderFns } from "./BookingRecordDetail.vue?vue&type=template&id=34a32124"
import script from "./BookingRecordDetail.vue?vue&type=script&lang=js"
export * from "./BookingRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./BookingRecordDetail.vue?vue&type=style&index=0&id=34a32124&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports